const ROOT = 'RATE_ENGINE_LIST_SHORT_';

const actionTypes = {
  FETCH_REQUEST: `${ROOT}FETCH_REQUEST`,
  FETCH_SUCCESS: `${ROOT}FETCH_SUCCESS`,
  FETCH_ERROR: `${ROOT}FETCH_ERROR`,
} as const;

export default actionTypes;
